import * as TYPES from "./mutations-types.js";
import * as CONFIG from "../../../config.js";
import { POP_RECORD_PREVIOUS, RECORD_PREVIOUS } from "./mutations-types.js";

function saveStateInSession(state) {
    // When JWT_COOKIE_ONLY is enabled, save auth state but exclude the token
    // The token is handled via HTTP-only cookies set by the server
    let stateToSave = state;

    if (CONFIG.JWT_COOKIE_ONLY) {
        // Create a copy of state without the token value
        // Use null instead of delete to preserve Vue 2 reactivity on reload
        stateToSave = { ...state, token: null };
    }

    if ("permanent" in CONFIG && CONFIG.permanent) {
        localStorage.setItem("auth_state", JSON.stringify(stateToSave));
    } else {
        sessionStorage.setItem("auth_state", JSON.stringify(stateToSave));
    }
}

export default {
    [TYPES.RECORD_PREVIOUS](state) {
        if (state.prev == null) {
            // Only do if there is not already a Previous entry.
            state.prev = {
                user: state.user,
                token: state.token,
                refreshToken: state.refreshToken,
            };
        }
        saveStateInSession(state);
    },
    [TYPES.POP_RECORD_PREVIOUS](state) {
        var value = state.prev;

        state.user = value.user;
        state.token = value.token;
        state.refreshToken = value.refreshToken || null; // Backward compatibility
        state.prev = null; // no longer in SUDO

        saveStateInSession(state);
    },
    [TYPES.SET_TOKEN](state, value) {
        state.token = value;

        saveStateInSession(state);
    },
    [TYPES.SET_REFRESH_TOKEN](state, value) {
        state.refreshToken = value;

        saveStateInSession(state);
    },
    [TYPES.SET_USER](state, value) {
        state.user = value;
        saveStateInSession(state);
    },
    [TYPES.SET_PERMISSION](state, value) {
        state.permissions = value;

        if (value != null) {
            state.use_permissions = true;
        } else {
            state.use_permissions = false;
        }
        saveStateInSession(state);
    },
    [TYPES.SET_USE_PERMISSION](state, value) {
        state.use_permissions = value;
        saveStateInSession(state);
    },
    [TYPES.TOKEN_EXPIRED](state) {
        state.user = null;
        state.token = null;
        state.refreshToken = null;
        state.prev = null; // no previous

        saveStateInSession(state);
    },
    [TYPES.REFRESH_TOKEN](state) {
        state.refreshing_token = true;
        saveStateInSession(state);
    },
    [TYPES.DONE_REFRESH_TOKEN](state) {
        state.refreshing_token = false;
        saveStateInSession(state);
    },
};
